import { InputLabel, OutlinedInput } from "@mui/material";
import styled from "styled-components";

export const FieldLabel = styled(InputLabel)`
  text-align: left;
  font: normal normal normal 22px Open Sans;
  color: ${({ theme }) => {
    return theme.colors.title;
  }};
`;

export const StyledField = styled(OutlinedInput)`
  & .MuiOutlinedInput-input {
    text-align: left;
    font: normal normal normal 16px/17px Open Sans;
    opacity: 1;
    color: ${({ theme }) => {
      return theme.colors.title;
    }};
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    height: 7px;
  }
`;
